import React, { useEffect, useState } from "react";
import Select from "../Select/Select.jsx";

const RecentlyViewedListMobile = () => { 
  const [options, setOptions] = useState([]);

  useEffect(() => {
    try {
      const stored = localStorage.getItem("recentlyViewed");
      if (stored) {
        const parsed = JSON.parse(stored);
        if (parsed.length > 0) {
          const transformed = parsed.map(item => ({
            label: item.title,
            value: item.url
          }));
          setOptions(transformed);
        } else {
          setOptions([{ label: "No Recently Viewed Documents", value: "", disabled: true }]);
        }
      } else {
        setOptions([{ label: "No Recently Viewed Documents", value: "", disabled: true }]);
      }
    } catch (err) {
      console.error("Error reading recentlyViewed:", err);
      setOptions([{ label: "No Recently Viewed Documents", value: "", disabled: true }]);
    }
  }, []);

  const handleRecentlyViewedSelection = (selected) => {
    // Handle navigation for recently viewed items
    if (selected.value && !selected.disabled) {
      window.location.href = selected.value;
    }
  };

  return ( 
    <div className="recently-viewed-mobile-container">
      <Select 
        componentName="recentlyViewedMobile"
        title="Recently Viewed"
        placeholder="Recently Viewed"
        options={options}
        isScrollTo={false}
        isNavigateOnChange={false} // Disable vanilla JS navigation since we handle it in callback
        callback={handleRecentlyViewedSelection}
      />
    </div>
  );
};

export default RecentlyViewedListMobile;
